'use client';

type Settings = Record<string, string | number | boolean>;

export const setupFeatureOverrides = (serverSettings: Settings): Settings => {
  const properties = {...serverSettings};

  // IncentiveOffers
  properties['login.bonus.enabled'] = true;

  // Versus screen timers
  properties['vs.endseconds'] = 1;
  properties['vs.tickertime'] = 4;

  // FTUE
  properties['ftue_match_code_focused'] = false;

  // Account deletion is an requirement from the AppStore
  // Other users should delete account via Support tickets
  properties['account.deletion.enabled'] = false;

  // Training bot not available on web yet
  properties['ftue.trainingbot.enabled'] = false;
  properties['FTUEConversionsDisabled'] = true;

  return properties;
};
